export function resolveSectionId(section) {
  return Number(section?.section_id ?? section?.backend_id ?? section?.id ?? null);
}

export function resolveMainSectionId(main_section) {
  return Number(main_section?.main_section_id ?? main_section?.id ?? main_section?.backend_id ?? null);
}

export function updateSectionExpandedState(section, target_section_id, expanded) {
  if (resolveSectionId(section) !== target_section_id) return section;
  const updated_main_section  = { ...section, expanded: expanded };
  return updated_main_section;
}

export function updateMainSectionDeletingState(main_section, target_main_section_id, is_deleting) {
  if (resolveMainSectionId(main_section) !== target_main_section_id) return main_section;
  const main_section_deleting_state  = { ...main_section, is_deleting: is_deleting };
  return main_section_deleting_state;
}

export function updateSectionDeletingState(section, target_section_id, is_deleting) {
  if (resolveSectionId(section) !== target_section_id) return section;
  const update_section  = { ...section, is_deleting: is_deleting };
  return update_section
}

export function mapSectionsWithExpandedState(sections, target_section_id, expanded) {
  return (Array.isArray(sections) ? sections : []).map((section) => {
    return updateSectionExpandedState(section, target_section_id, expanded);
  });
}

export function mapQuestionsWithUnassigningState(questions, target_question_id, is_unassigning, updateQuestionUnassigningState) {
  return (questions || []).map((question) => {
    return updateQuestionUnassigningState(question, target_question_id, is_unassigning);
  });
}

export function resolveEditableSection(ctx, section_ref, resolveSectionRef) {
  const section = resolveSectionRef(ctx, section_ref);
  const section_id = Number(section?.backend_id ?? section?.id);
  if (!section || !section_id) {
    return null;
  }
  const edit_section  = {
    section,
    section_id,
  };
  return edit_section;
}

export function syncMainSectionDeletingState(ctx, normalized_main_section_id, is_deleting) {
  ctx.main_sections = (Array.isArray(ctx.main_sections) ? ctx.main_sections : []).map((main_section) => {
    const next_main_section = updateMainSectionDeletingState(main_section, normalized_main_section_id, is_deleting);
    return next_main_section;
  });
}

export function syncCurrentEditMainSection(ctx, normalized_main_section_id, is_deleting) {
  const is_current_main_section = Number(ctx.current_edit_main_section?.main_section_id || 0) === normalized_main_section_id;
  if (is_current_main_section) {
    ctx.current_edit_main_section = { ...ctx.current_edit_main_section, is_deleting: is_deleting };
  }
}

export function hasProjectQuestionContext(question_id, form_id) {
  const has_context = Boolean(Number(question_id) && Number(form_id));
  return has_context;
}

export function normalizeProjectId(project_id) {
  const normalized_project_id = String(project_id || '').trim();
  return normalized_project_id;
}

export function resetCurrentEditQuestion(ctx) {
  ctx.current_edit_question = {
    question_id: null,
    question_text: '',
    question_description: '',
    question_type_id: '',
    is_mandatory: true,
    is_unique: false,
    question_number: '',
    show_option_inputs: false,
    option_inputs: ['', ''],
    multi_select_options: [],
    dependant_questions: [],
  };
}
